__turbopack_context__.v({
  "className": "apercumono_5fed09b5-module__mAWRiW__className",
  "variable": "apercumono_5fed09b5-module__mAWRiW__variable",
});
